import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { membershipTabs } from '@/mocks/home';

export default function Membership() {
  const [active, setActive] = useState(membershipTabs[0].key);
  const current = membershipTabs.find((t) => t.key === active) ?? membershipTabs[0];

  return (
    <section id="membership" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Membership & Free"
          title="会员和免费看，差别在哪"
          desc="两者不是二选一的对立关系。你可以先看免费内容，觉得合适再考虑会员；也可以按使用频率判断哪种方式更适合自己。"
        />

        <div className="mt-8 inline-flex rounded-full border border-background-200 bg-background-100 p-1">
          {membershipTabs.map((t) => {
            const isActive = t.key === active;
            return (
              <button
                key={t.key}
                type="button"
                onClick={() => setActive(t.key)}
                aria-pressed={isActive}
                className={`inline-flex items-center gap-2 rounded-full px-5 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                <i className={t.icon}></i>
                {t.label}
              </button>
            );
          })}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
          <div>
            <p className="text-sm leading-relaxed text-foreground-700 md:text-base">{current.intro}</p>
            <ul className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {current.items.map((item) => (
                <li
                  key={item}
                  className="flex gap-2.5 rounded-lg border border-background-200 bg-background-100 p-3.5 text-sm leading-relaxed text-foreground-700"
                >
                  <i className="ri-checkbox-circle-fill mt-0.5 shrink-0 text-primary-500"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-xs leading-relaxed text-foreground-500">
              说明：具体权益与清晰度可能随平台调整，实际以进入后的页面提示为准，本页仅作方向性说明。
            </p>
          </div>

          <div className="overflow-hidden rounded-2xl border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20dark%20cinema%20concept%20still%20with%20a%20glowing%20golden%20crown%20symbol%20floating%20above%20a%20screen%20in%20deep%20red%20and%20amber%20tones%2C%20premium%20membership%20theme%2C%20moody%20studio%20lighting%2C%20clean%20minimal%20composition%2C%20luxurious%20editorial%20visual&width=900&height=700&seq=member-hongtao-03&orientation=landscape"
              alt="会员权益主题的视觉示意"
              className="h-auto w-full object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}